import { API_PATHS, interpolatePathParams, REQUEST_METHODS, ROUTE_PARAMS } from '@futrli/shared-services';
import { PerformanceDashboard } from '@futrli-sdk/performance_dashboards';

import { makeRequestWithResponse } from '../shared';

/**
 * Fetch Performance dashboard
 *
 * @param {string} workspaceId - workspace to get the organisations from
 * @param {string} organisationId - organisation to get plays from
 * @returns {Promise<>} - Returns Performance dashboards
 * @throws error
 */
export const fetchPerformanceDashboards = async (
  workspaceId: string,
  organisationId: string
): Promise<PerformanceDashboard[]> => {
  const path = interpolatePathParams(API_PATHS.PERFORMANCE_DASHBOARDS, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });

  return makeRequestWithResponse<PerformanceDashboard[]>({ url: path });
};

/**
 * Add to Performance dashboards
 *
 * @param {string} workspaceId - workspace to get the organisations from
 * @param {string} organisationId - organisation to get plays from
 * @param {string} dashboardId - dashboardId (reportId) to add to performance dashboards
 * @param {string} reportName - dashboard name
 * @returns {Promise<>} - Returns created Performance dashboard
 * @throws error
 */
export const addToPerformanceDashboards = async (
  workspace_id: string,
  organisation_id: string,
  report_id: string,
  report_name: string,
  order?: number | null
): Promise<PerformanceDashboard> => {
  const path = interpolatePathParams(API_PATHS.PERFORMANCE_DASHBOARDS, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisation_id,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspace_id
  });

  const data: { report_id: string; organisation_id: string; report_name: string; order?: number } = {
    report_id,
    organisation_id,
    report_name
  };
  if (order != null && order != undefined) {
    data.order = order;
  }

  return makeRequestWithResponse<PerformanceDashboard>({
    url: path,
    method: REQUEST_METHODS.POST,
    data
  });
};

/**
 * Remove from Performance dashboards
 *
 * @param {string} workspaceId - workspace to get the organisations from
 * @param {string} organisationId - organisation to get plays from
 * @param {string} dashboardId - dashboardId (reportId) to add to performance dashboards
 * @param {string} reportName - dashboard name
 * @returns {Promise<>} - Returns created Performance dashboard
 * @throws error
 */
export const removeFromPerformanceDashboards = async (
  workspaceId: string,
  organisationId: string,
  dashboardId: string
): Promise<void> => {
  const path = interpolatePathParams(API_PATHS.PERFORMANCE_DASHBOARD, {
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.DASHBOARD_ID]: dashboardId
  });

  return makeRequestWithResponse<void>({ url: path, method: REQUEST_METHODS.DELETE });
};
